import { render } from "./PageSynchronisation.vue?vue&type=template&id=480a4739&scoped=true"
import script from "./PageSynchronisation.vue?vue&type=script&lang=js"
export * from "./PageSynchronisation.vue?vue&type=script&lang=js"

import "./PageSynchronisation.vue?vue&type=style&index=0&id=480a4739&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480a4739"]])

export default __exports__